export const TENSOR_TYPE_NAMES: Record<number, string> = {
  0: 'float32',
  1: 'float16',
  2: 'int32',
  3: 'uint8',
  4: 'int64',
  5: 'string',
  6: 'bool',
  7: 'int16',
  8: 'complex64',
  9: 'int8',
  10: 'float64',
  11: 'complex128',
  12: 'uint64',
  14: 'variant',
  15: 'uint32',
  16: 'uint16',
  17: 'int4',
  18: 'bfloat16',
  19: 'int2',
  20: 'uint4',
};
